// extracted by mini-css-extract-plugin
export default {"Drawer":"ReviewRightDrawer_Drawer__oYZP9"};